"use strict";

import Dom from "common/Dom";
import * as handlers from "scripts/components/Cart/handlers";
var setInlineCartCheckoutButtonDisabledStatus =
  function setInlineCartCheckoutButtonDisabledStatus() {
    var policyAcknowledgementIsChecked = $(
        Dom.inlineCartPolicyAcknowledgement,
      ).prop("checked"),
      $checkoutButton = $(Dom.checkoutBtn),
      checkoutButtonHref = $checkoutButton.attr("data-href");
    if (policyAcknowledgementIsChecked) {
      $checkoutButton
        .removeClass("button--disabled")
        .attr("href", checkoutButtonHref);
    } else {
      $checkoutButton.addClass("button--disabled").attr("href", null);
    }
  };
var OVER_LIMIT_MESSAGE =
  "Sorry, you have reached the maximum quantity of this product.";
export const bindActions = function bindActions() {
  $(document).on("cart.ready", function () {
    handlers.setCartState();
    handlers.updateCart();
    handlers.updateSubtotal();
    setInlineCartCheckoutButtonDisabledStatus();
  });
  $(document).on("cart.requestComplete", function (event) {
    handlers.setCartState();
    handlers.updateCart();
    handlers.updateSubtotal();
  });
  $(Dom.atcForm).on("submit", function (event) {
    var $form = $(event.currentTarget);
    var field = $form.serializeArray().find(function (field) {
      return field.name === "id";
    });
    var quantityLimit = parseInt(
      event.target.getAttribute("data-quantity-limit"),
    );
    var productType = event.target.getAttribute("data-product-type");
    event.preventDefault();
    if (!quantityLimit && productType === "medical-thermometers") {
      quantityLimit = 2;
    }
    if (quantityLimit) {
      window.CartJS.getCart()
        .then(function (cart) {
          var foundItem = cart.items.find(function (item) {
            return item.id === parseInt(field.value);
          });
          // check if item exists in the cart already
          if (foundItem !== undefined && foundItem) {
            // check for current quantity
            var newQuantity = foundItem.quantity + 1;
            if (quantityLimit && newQuantity > quantityLimit) {
              alert(OVER_LIMIT_MESSAGE);
              return;
            } else {
              handlers.addCartItem(field.value);
            }
          } else {
            handlers.addCartItem(field.value);
          }
        })
        .catch(function (err) {
          console.error("error getting cart", err);
        });
    } else {
      handlers.addCartItem(field.value);
    }
  });
  $(Dom.cartShow).on("click", function (event) {
    event.preventDefault();
    handlers.showCart(this);
  });
  $(Dom.cartHide).on("click", function (event) {
    event.preventDefault();
    handlers.hideCart();
  });
  $(Dom.overlay).on("click", function () {
    handlers.hideCart();
  });
  $(document).on("keydown", function (event) {
    if (event.key === "Escape" && $(Dom.inlineCart).hasClass("is-active")) {
      handlers.hideCart();
    }
  });
  $(Dom.inlineCart).on("change", "[data-quantity-number]", function () {
    handlers.updateQuantityByText($(this));
  });
  $(Dom.inlineCart).on("click", "[data-quantity-change]", function () {
    handlers.updateQuantityByIncrement($(this));
  });
  $(Dom.productId).on("click", function (event) {
    var productType = $(event.target).attr("data-product-type");
    var quantityLimit = $(event.target).attr("data-quantity-limit");
    var atcId = $(event.target).attr("data-atc-product-id");
    event.preventDefault();
    if (!quantityLimit && productType === "medical-thermometers") {
      quantityLimit = 2;
    }
    if (quantityLimit) {
      window.CartJS.getCart()
        .then(function (cart) {
          var foundItem = cart.items.find(function (item) {
            return item.id === parseInt(atcId);
          });
          // check if item exists in the cart already
          if (foundItem !== undefined && foundItem) {
            // check for current quantity
            var newQuantity = foundItem.quantity + 1;
            if (quantityLimit && newQuantity > quantityLimit) {
              alert(OVER_LIMIT_MESSAGE);
              return;
            } else {
              handlers.addCartItem(atcId, 1);
            }
          } else {
            handlers.addCartItem(atcId, 1);
          }
        })
        .catch(function (err) {
          console.error("error getting cart", err);
        });
    } else {
      handlers.addCartItem(atcId, 1);
    }
  });
  $(Dom.inlineCartPolicyAcknowledgement).on(
    "change",
    setInlineCartCheckoutButtonDisabledStatus,
  );
};
